export const getShirtOptions = state => state.garmentTypes.byType['shirt']
